import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth/auth-config";

const Login: React.FC = () => {
	const { instance } = useMsal();

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const mode = urlParams.get("m") === "create" ? "create" : "login";

		instance
			.loginRedirect({
				...loginRequest,
				prompt: mode,
				extraQueryParameters: {
					ui_locales: navigator.language,
					mkt: navigator.language
				}
			})
			.catch((error: any) => {
				console.error("Erreur lors de la redirection MSAL :", error);
			});
	}, [instance, navigator]); // Exécuté uniquement au premier rendu

	return null; // Aucun affichage, juste une redirection immédiate
};

export default Login;
